// @ts-nocheck

// import useInput from "hooks/use-input";
import useInput from "../../../../hooks/use-input";
import { useState, useEffect } from "react";
import { OnChangeValue } from "react-select";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import Time from "react-time-period-picker";
import { useParams } from "react-router-dom";
// import { connection } from "../../utils/apiConnection.ts";
import useAxios from "../../../../services/useAxios";
import { isString } from "lodash";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
// import "./react-time-period-picker/dist/time.css";
export default function ShopSetting({
  inputChangeHandler,
  inputFileHandler,
  changeHandler,
  otherInfo,
  setUpdater,
}) {
  const { execute: edit_supplier } = useAxios("superadminapi/edit_supplier");
  async function edit_supplierFun(temp) {
    await edit_supplier({
      ...temp,
      supplier_id: id.supplier_id,
      main_status: 0,
      main_cat: otherInfo.main_cat,
      title: otherInfo.title,
      description: otherInfo.description,
      address: otherInfo.address,
      site: otherInfo.site,
      instagram: otherInfo.instagram,
      tell1: otherInfo.tell1,
      tell2: otherInfo.tell2,
      email: otherInfo.email,
      mobile: otherInfo.mobile,
      main_admin_uid: otherInfo.main_admin_uid,
      start_hour: otherInfo.start_hour,
      finish_hour: otherInfo.finish_hour,
      start_min: otherInfo.start_min,
      finish_min: otherInfo.finish_min,
      count_rate: otherInfo.count_rate,
      min_order_amount: removeCommas(otherInfo.min_order_amount),
      complate_order_count: otherInfo.complate_order_count,
      active_order_count: otherInfo.active_order_count,
      canceled_order_count: otherInfo.canceled_order_count,
      total_saled_amount: otherInfo.total_saled_amount,
    }).then((res) => {
      if (res.status === 1) {
        toast.success("اطلاعات فروشگاه با موفقیت ویرایش گردید.");
        setUpdater((prev) => !prev);
      } else {
        toast.error("مشکلی پیش آمده لطفا بعدا امتحان کنید.");
      }
    });
  }
  // console.log(supplier);
  // const [supplierData, setSupplierData] = useState({});
  // const [otherInfo, setOtherInfo] = useState({
  //   state: "",
  //   city: "",
  //   address: "",
  //   title: "",
  //   start_hour: "",
  //   end_hour: "",
  //   start_min: "",
  //   end_min: "",
  //   min_order_amount: 0,
  //   logo: [],
  //   cover: [],
  //   tell1: "",
  //   tell2: "",
  //   mobile: "",
  //   email: "",
  // });

  // useEffect(() => {
  //   connection("superadminapi/get_edit_suppliers_data", {
  //     supplier_id: 5,
  //   }).then((datas) => {
  //     setSupplierData(datas.supplier[0]);
  //     setOtherInfo(datas.supplier[0]);
  //   });
  // }, []);

  // const changeHandler = (names, value) => {
  //   if (names == "start") {
  //     setOtherInfo((prev) => {
  //       return {
  //         ...prev,
  //         start_hour: value.split(":")[0],
  //         start_min: value.split(":")[1],
  //       };
  //     });
  //   } else if (names == "finish") {
  //     setOtherInfo((prev) => {
  //       return {
  //         ...prev,
  //         finish_hour: value.split(":")[0],
  //         finish_min: value.split(":")[1],
  //       };
  //     });
  //   }
  // };

  const title = useInput((value) => value.trim() !== "");
  // const [otherInfo, setOtherInfo] = useState({
  //   state: "",
  //   city: "",
  //   address: "",
  //   title: "",
  //   start_hour: "",
  //   end_hour: "",
  //   start_min: "",
  //   end_min: "",
  //   min_order_amount: 0,
  //   logo: [],
  //   cover: [],
  //   tell1: "",
  //   tell2: "",
  //   mobile: "",
  //   email: "",
  // });

  // useEffect(() => {
  //   setOtherInfo(supplierData);
  // }, []);
  // const [editable, setEditable] = useState(false);

  const [catagories, setCatagories] = useState([
    { title: "پروتئین", status: false },
    { title: "میوه و تره بار", status: false },
    { title: "سوپر مارکت", status: false },
    { title: "قنادی", status: false },
    { title: "سلامتی و زیبایی", status: false },
  ]);
  // const changeHandler = (names, value) => {
  //   setOtherInfo((prev) => {
  //     return { ...prev, [names]: value };
  //   });
  // };

  // function inputChangeHandler(event: Event) {
  //   setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
  // }
  let id = useParams();
  // function startHourHandler(event: Event) {
  //   setOtherInfo({ ...otherInfo, [event.target.name]: event.target.value });
  // }
  function checkBoxHandler(i: number) {
    setCatagories((prev) =>
      prev.map((value, index) => {
        if (index == i) return { ...value, status: !value.status };
        return value;
      })
    );
  }

  function editShop() {
    let formSetting = new FormData();

    // formSetting.append("main_cat", otherInfo.main_cat);
    // formSetting.append("title", otherInfo.title);
    // formSetting.append("description", otherInfo.description);
    // otherInfo.cover_file_id != "" &&
    //   formSetting.append("cover_file_id", otherInfo.cover_file_id);
    // otherInfo.logo_file_id != "" &&
    //   formSetting.append("logo_file_id", otherInfo.logo_file_id);
    // formSetting.append("address", otherInfo.address);
    // formSetting.append("tell1", otherInfo.tell1);
    // formSetting.append("tell2", otherInfo.tell2);
    // formSetting.append("email", otherInfo.email);
    // formSetting.append("mobile", otherInfo.mobile);
    // formSetting.append("main_admin_uid", otherInfo.main_admin_uid);
    // formSetting.append("mtm", otherInfo.mtm);
    // formSetting.append("uptm", otherInfo.uptm);
    // formSetting.append("upuid", otherInfo.upuid);
    // formSetting.append("main_status", otherInfo.main_status);
    // formSetting.append("start_hour", otherInfo.start_hour);
    // formSetting.append("finish_hour", otherInfo.finish_hour);
    // formSetting.append("start_min", otherInfo.start_min);
    // formSetting.append("finish_min", otherInfo.finish_min);
    // formSetting.append("avg_rate", otherInfo.avg_rate);
    // formSetting.append("count_rate", otherInfo.count_rate);
    // formSetting.append("min_order_amount", otherInfo.min_order_amount);
    // formSetting.append("complate_order_count", otherInfo.complate_order_count);
    // formSetting.append("active_order_count", otherInfo.active_order_count);
    // formSetting.append("canceled_order_count", otherInfo.canceled_order_count);
    // formSetting.append("total_saled_amount", otherInfo.total_saled_amount);
    // formSetting.append("supplier_id", id.supplier_id);
    let temp = {};
    if (!isString(otherInfo.cover_file_id)) {
      temp = { ...temp, cover_file_id: otherInfo.cover_file_id };
    }
    if (!isString(otherInfo.logo_file_id)) {
      temp = { ...temp, logo_file_id: otherInfo.logo_file_id };
    }
    edit_supplierFun(temp);

    // toast.success("اطلاعات فروشگاه با موفقیت ویرایش گردید.");
    // if (false) {
    //   Swal.fire({
    //     title: "خطا!",
    //     text: "مشکلی پیش آمده است، لطفا بعدا امتحان کنید.",
    //     icon: "error",
    //     confirmButtonColor: "#0d6efd",
    //     confirmButtonText: "متوجه شدم",
    //   });
    // }
  }
  const pattern = /^09\d{9}$/;
  const tellPattern = /^0\d{10}$/;
  const [valid, setValid] = useState({
    tell1: true,
    tell2: true,
    mobile: true,
  });
  const validate = () => {
    let isValide = true;
    if (pattern.test(otherInfo.mobile) || otherInfo.mobile == "") {
      setValid((prev) => {
        return { ...prev, mobile: true };
      });
    } else if (!pattern.test(otherInfo.mobile)) {
      setValid((prev) => {
        return { ...prev, mobile: false };
      });
      isValide = false;
    }
    if (tellPattern.test(otherInfo.tell1) || otherInfo.tell1 == "") {
      setValid((prev) => {
        return { ...prev, tell1: true };
      });
    } else if (!tellPattern.test(otherInfo.tell1)) {
      setValid((prev) => {
        return { ...prev, tell1: false };
      });
      isValide = false;
    }
    if (tellPattern.test(otherInfo.tell2) || otherInfo.tell2 == "") {
      setValid((prev) => {
        return { ...prev, tell2: true };
      });
    } else if (!tellPattern.test(otherInfo.tell2)) {
      setValid((prev) => {
        return { ...prev, tell2: false };
      });
      isValide = false;
    }
    if (otherInfo.title == "") {
      isValide = false;
    }
    return isValide;
  };
  console.log("otherInfo", otherInfo);

  // console.log("supplierData", supplierData);
  return (
    <div className="shop-setting d-flex justify-content-center">
      <form className="w-100 d-flex flex-column align-items-center">
        <div className="form-main-inputs d-flex flex-wrap">
          <div className="d-flex flex-wrap align-items-center mb-3 w-100">
            <label
              htmlFor="shop-title"
              className="form-label col-12 col-lg-2 label-5 mb-0"
            >
              نام فروشگاه
            </label>
            <div className="col-12 col-lg-4 ">
              <input
                style={{ background: "#ddd" }}
                type="text"
                id="shop-title"
                name="title"
                className="form-control input-5 rounded-pill"
                // defaultValue="k"
                // value={otherInfo.title}
                // onChange={(e) => {
                //   changeHandler("title", e.target.value);
                // }}

                value={otherInfo.title}
                onChange={inputChangeHandler}
              />
              <p
                className="validate-text"
                style={{ display: otherInfo.title == "" ? "block" : "none" }}
              >
                نام فروشگاه را وارد کنید.
              </p>
            </div>
            <label
              htmlFor="shop-logo"
              className="form-label col-12 col-lg-2 label-5 mt-2"
            >
              لوگو
            </label>
            <div className="col-12 col-lg-4 ">
              <input
                style={{ background: "#ddd" }}
                type="file"
                id="shop-logo"
                name="logo_file_id"
                className="form-control input-5 rounded-pill"
                onChange={inputFileHandler}
                // onChange={(e) => {
                //   changeHandler("logo", e.target.files[0]);
                // }}
                value={otherInfo.logo}
                // onChange={inputChangeHandler}
              />
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center mb-3 w-100">
            <label
              htmlFor="shop-site"
              className="form-label col-12 col-lg-2 label-5 mb-0"
            >
              اینستاگرام
            </label>
            <div className="col-12 col-lg-10">
              <input
                style={{ background: "#ddd" }}
                type="text"
                id="shop-site"
                name="site"
                className="form-control input-5 rounded-pill"
                // onChange={(e) => {
                //   changeHandler("site", e.target.value);
                // }}
                // defaultValue={supplierData.prop.site}
                value={otherInfo.site}
                onChange={inputChangeHandler}
              />
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center mb-3 w-100">
            {" "}
            <label
              htmlFor="shop-instagram"
              className="form-label col-12 col-lg-2 label-5 mb-0"
            >
              سایت
            </label>
            <div className="col-12 col-lg-4  ">
              <input
                style={{ background: "#ddd" }}
                type="text"
                id="shop-instagram"
                name="instagram"
                className="form-control input-5 rounded-pill"
                // onChange={(e) => {
                //   changeHandler("instagram", e.target.value);
                // }}
                // defaultValue={supplierData.prop.instagram}
                value={otherInfo.instagram}
                onChange={inputChangeHandler}
              />
            </div>
            <label
              htmlFor="shop-email"
              className="form-label col-12 col-lg-2 label-5 mt-2"
            >
              ایمیل
            </label>
            <div className="col-12 col-lg-4 ">
              <input
                style={{ background: "#ddd" }}
                type="text"
                id="shop-email"
                name="email"
                className="form-control input-5 rounded-pill"
                // onChange={(e) => {
                //   changeHandler("email", e.target.value);
                // }}
                // defaultValue={supplierData.prop.email}
                value={otherInfo.email}
                onChange={inputChangeHandler}
              />
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center mb-3 w-100">
            <label
              htmlFor="shop-tell1"
              className="form-label col-12 col-lg-2 label-5 mb-0"
            >
              تلفن
            </label>
            <div className="col-12 col-lg-4 ">
              <input
                style={{ background: "#ddd" }}
                type="number"
                id="shop-tell1"
                name="tell1"
                className="form-control input-5 rounded-pill"
                // onChange={(e) => {
                //   changeHandler("tell1", e.target.value);
                // }}
                // defaultValue={supplierData.prop.tell1}
                value={otherInfo.tell1}
                onChange={inputChangeHandler}
              />
              <p
                className="validate-text"
                style={{ display: !valid.tell1 ? "block" : "none" }}
              >
                شماره وارد شده صحیح نیست.
              </p>
            </div>

            <label
              htmlFor="shop-mobile"
              className="form-label col-12 col-lg-2 label-5 mt-2"
            >
              موبایل
            </label>
            <div className="col-12 col-lg-4 ">
              <input
                style={{ background: "#ddd" }}
                type="number"
                id="shop-mobile"
                name="mobile"
                className="form-control input-5 rounded-pill"
                // onChange={(e) => {
                //   changeHandler("mobile", e.target.value);
                // }}
                // defaultValue={supplierData.prop.mobile}
                value={otherInfo.mobile}
                onChange={inputChangeHandler}
              />
              <p
                className="validate-text"
                style={{ display: !valid.mobile ? "block" : "none" }}
              >
                شماره وارد شده صحیح نیست.
              </p>
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center mb-3 w-100">
            <label
              htmlFor="shop-address"
              className="form-label col-12 col-lg-2 label-5 mb-0"
            >
              آدرس
            </label>
            <div className="col-12 col-lg-10 ">
              <textarea
                style={{ background: "#ddd" }}
                type="text"
                id="shop-address"
                name="address"
                className="form-control input-5 rounded-pill"
                // onChange={(e) => {
                //   changeHandler("address", e.target.value);
                // }}
                // defaultValue={supplierData.prop.address}
                value={otherInfo.address}
                onChange={inputChangeHandler}
              />
            </div>
          </div>

          <div className="d-flex flex-wrap align-items-center mb-3 w-100">
            <label className="form-label col-12 col-lg-2 label-5 mb-0">
              ساعت
            </label>
            <div className=" col-lg-4 col-12 ">
              <input
                style={{
                  background: "#ddd",
                  fontSize: "14px",
                  height: "45px",
                }}
                type="time"
                id="shop-start_hour"
                name="start_hour"
                className="form-control input-5 rounded-pill"
                value={`${otherInfo.start_hour}:${otherInfo.start_min}`}
                // onChange={inputChangeHandler}
                onChange={(e) => {
                  changeHandler("start", e.target.value);
                }}
              />
            </div>
            <label className="form-label col-12 col-lg-2 label-5 mt-2">
              الی
            </label>
            <div className="col-lg-4 col-12">
              <input
                style={{
                  background: "#ddd",
                  fontSize: "14px",
                  height: "45px",
                }}
                type="time"
                id="shop-end_hour"
                name="end_hour"
                className="form-control input-5 rounded-pill"
                value={`${otherInfo.finish_hour}:${otherInfo.finish_min}`}
                // onChange={inputChangeHandler}
                onChange={(e) => {
                  changeHandler("finish", e.target.value);
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-wrap align-items-center mb-3 w-100">
            <label
              htmlFor="shop-min_order_amount"
              className="form-label col-12 col-lg-2 label-5 mb-0"
            >
              حداقل سفارش
            </label>
            <div className="col-12 col-lg-4 ">
              <input
                style={{ background: "#ddd" }}
                type="text"
                id="shop-min_order_amount"
                name="min_order_amount"
                className="form-control input-5 rounded-pill"
                // defaultValue={supplierData.prop.min_orer_amount}
                value={addCommas(otherInfo.min_order_amount)}
                onChange={inputChangeHandler}
              />
            </div>
          </div>
        </div>
        <div>
          {/* <Time
            onChange={(es) => {
              console.log(es);
            }}
          /> */}
        </div>
        <div className="hr"></div>
        {/* <div className="catagories d-flex flex-wrap">
          {catagories.map((value, index) => (
            <div
              className="form-control catagory-boxes"
              key={`shop-setting-cat-${index}`}
            >
              <input
                style={{ background: "#ddd" }}
                id={`cat-checkbox-${index}`}
                type="checkbox"
                className="form-check-input"
                checked={value.status}
                onChange={() => checkBoxHandler(index)}
              />
              <label
                htmlFor={`cat-checkbox-${index}`}
                className="form-check-label"
              >
                {value.title}
              </label>
            </div>
          ))}
        </div> */}
        <div className="buttons">
          <button
            type="button"
            className="btn submit-btn "
            onClick={(e) => {
              e.preventDefault();
              console.log("kk");

              if (validate()) {
                editShop();
              }
            }}
          >
            ثبت
          </button>
          {/* {editable ? (
            
          ) : (
            <button
              type="button"
              className="btn edit-btn"
              onClick={(e) => {
                e.preventDefault();
                setEditable((prev) => !prev);
              }}
            >
              ویرایش
            </button>
          )} */}
        </div>
      </form>
    </div>
  );
}
